import { Outlet, useLocation } from 'react-router-dom';

import Header from 'components/layouts/Header';
import Navbar from 'components/layouts/Navbar';
import Menu from 'components/layouts/Menu';

import { useState } from 'react';

export default function DefaultLayout() {
  // hooks
  const location = useLocation();

  // state
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const isPlayPage = location.pathname === '/play';

  return (
    <div
      className={`relative mx-auto flex h-full max-w-[1024px] flex-col ${isPlayPage ? 'bg-[url(assets/images/play_background.png)] bg-cover bg-center' : 'bg-[url(assets/images/background.png)] bg-contain'}`}
    >
      <Header setIsOpenMenu={setIsOpenMenu} />
      <main className={`h-[calc(100dvh-64px)] flex-1 pt-[64px] ${isPlayPage && 'h-[calc(100dvh-160px)] pb-[96px]'}`}>
        <Outlet />
      </main>
      {isPlayPage && (
        <>
          <Navbar />
          {isOpenMenu && <Menu setIsOpenMenu={setIsOpenMenu} />}
        </>
      )}
    </div>
  );
}
